module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/character-confirmation@2x-89042025c7f23dadba3175d01cc6bf46.png";